import MixpanelPluginV2 from '@satellite/plugins/MixpanelPluginV2.js';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';

import config from '@/config';

export function createJunoAnalyticsClient(): AnalyticsClient {
  const mixpanel = new MixpanelPluginV2({
    token: config.mixpanel_token ?? null,
    enabled: Boolean(config.mixpanel_token),
    debug: config.server_env === 'development'
  });
  mixpanel.init();

  return {
    track: (event, payload) => mixpanel.track(String(event), payload),
    identify: value => {
      if (typeof value !== 'string' || !value) {
        return;
      }
      mixpanel.identify(value);
    },
    reset: () => mixpanel.reset(),
    registerSuper: props => mixpanel.setProperties(props),
    setUserProperties: props => mixpanel.setUserProperties(props)
  };
}
